import { existsMassElementForFormFüllung } from "../../arrangement/elementFunctions";
import { Auswahl } from "../Auswahl";
import { MAuswahlwert } from "../../../metamodell";

export function AuswahlVerteilungsstrategie(options) {
  const agt = APP.arrangement;
  const getSegmente = () =>
    agt.selectedObjects.length == 0
      ? agt.segmente
      : new Set(
          agt.selectedObjects
            .filter((s) => s.isElement || s.isEmpty || (s.isPfosten && !s.isPfostenAnEcke))
            .map((s) => s.segment)
        ).toArray();

  const elementeKürzbar = existsMassElementForFormFüllung(
    agt.massAuswahlwertDefault.Mass[0].Form,
    agt.füllungAuswahlwertDefault
  );
  const ungültigeKeys = elementeKürzbar ? [] : ["Gleichmässig", "StandardRechts", "StandardLinks"];
  let verteilungsstrategieAuswahlwert = agt.verteilungsstrategieAuswahlwert;
  const key = verteilungsstrategieAuswahlwert?.Key;
  if (ungültigeKeys.includes(key)) {
    verteilungsstrategieAuswahlwert = APP.richMetadata.findAuswahlwert(
      key === "StandardRechts" ? "LeerraumRechts" : "LeerraumLinks"
    );
  }
  return (
    <Auswahl
      {...options}
      Key="Verteilungsstrategie"
      value={verteilungsstrategieAuswahlwert}
      onChange={(verteilungsstrategieAuswahlwert: MAuswahlwert) => {
        if (agt.selectedObjects.length == 0) {
          agt.verteilungsstrategieAuswahlwert_ = verteilungsstrategieAuswahlwert;
        }
        const segmente = getSegmente();
        segmente.forEach(
          (s) => (s.verteilungsstrategieAuswahlwert = verteilungsstrategieAuswahlwert)
        );
        APP.dirty();
      }}
      ungültigeKeys={ungültigeKeys}
    />
  );
}
